<template>
  <div class="user-navbar">
    <div
      class="profile"
      @click="toggleMenuUserNavBarVisible()"
    >
      <user-avatar/>

      <div class="details">
        <span class="userName">{{ user.name }}</span>
        <balance class="userBalance"/>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import UserAvatar from '@/users/components/UserAvatar.vue';
import Balance from '@/credits/components/Balance.vue';
import currency from '@/support/filters/currency';

export default {
  name: 'User',

  methods: {
    ...mapMutations('dashboard', [
      'toggleMenuUserNavBarVisible',
    ]),

    /**
     * Check if element are inside a user navbar component.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreInsideUser(el) {
      try {
        let node = el.parentNode;

        while (node != null) {
          if ((node.className || '').indexOf('user-navbar') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },

    /**
     * Check if element are a user menu link.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreAMenuLink(el) {
      try {
        const elClassName = el.className || '';

        if (elClassName.indexOf('user-menu-item') > -1 && elClassName.indexOf('-is-link') > -1) {
          return true;
        }

        let node = el.parentNode;
        while (node != null) {
          const nodeClassName = node.className || '';

          if (nodeClassName.indexOf('user-menu-item') > -1 && nodeClassName.indexOf('-is-link') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },
  },

  computed: {
    ...mapState('dashboard', [
      'menuUserNavBarVisible',
    ]),
    ...mapState('auth', [
      'user',
    ]),
  },

  mounted() {
    document.addEventListener('click', ({ target }) => {
      const elementAreInsideUser = this.elementAreInsideUser(target);
      const elementAreAMenuLink = this.elementAreAMenuLink(target);

      if (
        this.menuUserNavBarVisible
        && (!elementAreInsideUser || (elementAreInsideUser && elementAreAMenuLink))
      ) {
        this.$store.commit('dashboard/hideMenuUserNavBar');
      }
    });
  },

  filters: {
    currency,
  },

  components: {
    UserAvatar,
    Balance,
  },
};
</script>

<style lang="scss" scoped>
  .user-navbar {
    position: relative;

    > .profile {
      @apply flex;
      cursor: pointer;
      align-items: flex-start;

      > .details {
        margin-left: 9px;
        margin-top: -5px;
        flex: 1;

        > .userName {
          @apply text-sm;
          color: #2b2b2b;
          font-weight: 700;
        }

        > .userBalance {
          &:not(.-loading) {
            @apply relative;
            font-size: 12px;
            line-height: 1;
            font-weight: 500;

            &:not(.-cantFetch) {
              color: rgba(43,43,43,0.7);
            }

            &:after {
              @apply relative;
              top: 1px;
              display: inline-block;
              width: 0;
              height: 0;
              margin-left: 0.355em;
              vertical-align: 0.255em;
              content: "";
              border-top: 0.3em solid;
              border-right: 0.3em solid transparent;
              border-bottom: 0;
              border-left: 0.3em solid transparent;
            }
          }
        }

        &:hover {
          > .userName {
            color: #212121;
          }

          > .userBalance {
            &:not(.-cantFetch) {
              @apply text-gray-600;
            }
          }
        }
      }
    }
  }
</style>
